'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var gpaBuilders = require('../../tokenModule/gpaBuilders.cjs');
var Operation = require('../../../types/Operation.cjs');

// -----------------
// Operation
// -----------------

const Key = 'FindNftsByOwnerOperation';

/**
 * Finds multiple NFTs and SFTs by a given owner.
 *
 * ```ts
 * const nfts = await metaplex
 *   .nfts()
 *   .findAllByOwner({ owner };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const findNftsByOwnerOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const findNftsByOwnerOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    const {
      programs
    } = scope;
    const {
      owner
    } = operation.input;
    const tokenProgram = metaplex.programs().getToken(programs);
    const mints = await new gpaBuilders.TokenGpaBuilder(metaplex, tokenProgram.address).selectMint().whereOwner(owner).whereAmount(1).getDataAsPublicKeys();
    scope.throwIfCanceled();
    const nfts = await metaplex.nfts().findAllByMintList({
      mints
    }, scope);
    scope.throwIfCanceled();
    return nfts.filter(nft => nft !== null);
  }
};

exports.findNftsByOwnerOperation = findNftsByOwnerOperation;
exports.findNftsByOwnerOperationHandler = findNftsByOwnerOperationHandler;
//# sourceMappingURL=findNftsByOwner.cjs.map
